import { withStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';

const styles = () => ({
  root: {
    '& > td:last-child': {
      width: 180,
    },
    '&:nth-of-type(even)': {
      backgroundColor: '#F9F9F9',
    },
  },
});

export default withStyles(styles)(TableRow);
